const wrap: React.CSSProperties = {
  maxWidth: 820,
  margin: "0 auto",
  padding: "48px 20px 72px",
  lineHeight: 1.7,
  color: "#333",
};

export default function Terms() {
  return (
    <main style={wrap}>
      <title>Terms of Service | Your Energy Guru</title>
      <meta
        name="description"
        content="The terms that govern your use of yourenergyguru.com, including how we make money and what we are (and aren't)."
      />
      <link rel="canonical" href="https://yourenergyguru.com/terms" />

      <h1>Terms of Service</h1>
      <p>
        <em>Effective date: July 24, 2026</em>
      </p>
      <p>
        By using yourenergyguru.com you agree to these terms. If you don't
        agree, please don't use the site.
      </p>

      <h2>What this site is (and isn't)</h2>
      <p>
        Your Energy Guru is a free educational resource and quote-matching
        service for homeowners considering solar.{" "}
        <strong>
          We are not a solar installer, contractor, lender, or utility, and we
          are not affiliated with any government program or agency.
        </strong>{" "}
        Articles, calculators, and estimates on this site are educational
        only: real-world pricing, production, and savings depend on your roof,
        your utility, your contract, and market conditions, and nothing here
        is a quote, guarantee, or professional advice. Always verify the
        numbers in any installer's written proposal before signing.
      </p>

      <h2>How we make money</h2>
      <p>
        When you request a quote, we connect you with partner solar providers,
        and those partners pay us for the introduction.{" "}
        <strong>This never changes the price you pay</strong>, and no partner
        pays us to influence the editorial content on this site. We think
        you'd rather know this plainly than find it in fine print — that's the
        deal that keeps the site free.
      </p>

      <h2>Using the site</h2>
      <p>
        You agree to submit accurate information in quote requests, use the
        site only for lawful personal purposes, and not scrape, spam, attack,
        or misuse it. Content on this site is our intellectual property (or
        used with permission) — feel free to quote it with a link and
        attribution; don't republish it wholesale.
      </p>

      <h2>Disclaimers & limitation of liability</h2>
      <p>
        The site is provided "as is" without warranties of any kind. We work
        hard to keep information current and accurate, but energy policy,
        incentives, and prices change quickly, and we make no guarantee of
        completeness or fitness for your situation. To the maximum extent
        permitted by law, Your Energy Guru is not liable for indirect,
        incidental, or consequential damages arising from your use of the
        site or from any transaction between you and a provider we introduce
        you to — your agreement for solar services is solely between you and
        that provider.
      </p>

      <h2>Governing law & changes</h2>
      <p>
        These terms are governed by the laws of the State of Florida. We may
        update these terms from time to time; continued use of the site after
        an update is acceptance of the revised terms. Questions? Reach us
        through our <a href="/contact">contact page</a>.
      </p>
    </main>
  );
}
